// extracted by mini-css-extract-plugin
export default {"waiting":"Irreversible_waiting__sK698","final":"Irreversible_final__wW2mT","unknown":"Irreversible_unknown__V0ao5"};